module.exports = __webpack_public_path__ + "img/institutional_wuzhen.793255cf.png";